import { InputText } from "primereact/inputtext";

export const FilterInput = (options) => (
    <span className=" w-full">
        <InputText value={options.value || ""} onChange={(e) => options.filterApplyCallback(e.target.value)} className="p-inputtext-sm" />
    </span>
);